import { useEffect, useState } from "react";
import { Job } from "../../../../store/model/jobModel";
import CenteredModal from "../../../elements/CenteredModal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Modal from "react-bootstrap/esm/Modal";
import SearchIcon from "../../../../assets/components/SearchIcon";
import Client from "../../../../model/Client";
import ClientSearchDialog from "../../../elements/Search/subcomponents/ClientSearchDialog";

interface MergeJobDialogProps {
    show: boolean;
    handleModalClose: () => void;
    handleConfirmation: (newName: string, client: Client | null, invoiceClient: Client | null) => void;
    selectedJobs: Job[];
}

const MergeJobDialog: React.FC<MergeJobDialogProps> = ({show, handleModalClose, handleConfirmation, selectedJobs}) => {
    const [newName, setNewName] = useState<string>("");
    const [client, setClient] = useState<Client | null>(null);
    const [invoiceClient, setInvoiceClient] = useState<Client | null>(null);
    const [showClientSearch, setShowClientSearch] = useState<boolean>(false);
    const [showInvoiceClientSearch, setShowInvoiceClientSearch] = useState<boolean>(false);    

    useEffect(() => {
        if(show && client === null){
            setClient(initClient(selectedJobs));
        }   

        if(show && invoiceClient === null){
            const newInvoiceClient = initInvoiceClient(selectedJobs);    
            setInvoiceClient(newInvoiceClient);
        }
        if(!show){
            resetDialog();
        }
    }, [show]);

    
    const initInvoiceClient = (selectedJobs: Job[]): Client | null => {
        if(selectedJobs.length === 0) return null;
        const firstJobClient = selectedJobs[0].invoiceClient;        
        if(firstJobClient === undefined || firstJobClient === null) return null;
        if(selectedJobs.every(job => job.invoiceClient !== undefined && job.invoiceClient?.clientId === firstJobClient.clientId))
        {
            return firstJobClient;
        } 

        return null;
    }

    const initClient = (selectedJobs: Job[]): Client | null => {
        
        if(selectedJobs.length === 0) return null;
        const firstJobClient = selectedJobs[0].client;

        if(firstJobClient === undefined || firstJobClient === null) return null;    
        if(selectedJobs.every(job => job.client !== undefined && job.client?.clientId === firstJobClient.clientId))
        {
            return firstJobClient;
        } 

        return null;
    }

    const resetDialog = () => {
        setNewName("");
        setClient(null);
        setInvoiceClient(null);        
    }

    const handleClientSearchResult = (client: Client) => {
        if(showClientSearch){            
            setClient(client);
        }
        if(showInvoiceClientSearch){            
            setInvoiceClient(client);
        }

        handleCloseClientSearch();
    }

    const handleCloseClientSearch = () => {
        setShowClientSearch(false);
        setShowInvoiceClientSearch(false);
    }
    
    return <>{!showClientSearch && !showInvoiceClientSearch && 
            <CenteredModal
                title="Merge Jobs"
                show={show}
                onHide={() => handleModalClose()}
                vCenter={true}                
            >
                
                    <p style={{padding: "1rem 0 0 1rem" }}>Please enter a new job name for the merged jobs to be collated in:</p>
                    <TextField
                        variant="outlined"
                        label="New Job Name"
                        value={newName}
                        margin="normal"
                        sx={{ margin: "1rem"}}
                        onChange={(e) => setNewName(e.currentTarget.value)}
                    />          
                    <p style={{padding: "1rem 0 0 1rem" }}>Select a client and invoice client for the new job:</p>
                    <Box display="flex" flexDirection="row" sx={{ margin: "1rem"}}>
                        <div className="p-2 d-flex align-items-center" key={0}>                                        
                            <TextField 
                                id="client-field"
                                label="Client"                                                                                                                                     
                                variant="outlined" 
                                disabled={true}                                            
                                value={client?.code &&  client?.name ? `${client.code} - ${client.name}`: ""}
                                InputProps={{
                                    endAdornment: ( <InputAdornment position="start">
                                        <IconButton onClick={() => setShowClientSearch(true)}><SearchIcon /></IconButton>
                                        </InputAdornment> 
                                    )                                              
                                }}                                                                                                                         
                            />
                        </div>
                        <div className="p-2 d-flex align-items-center" key={1}>
                            <TextField 
                                id="invoiceClient-field"
                                label="Bill To Client"                                                                                                                                     
                                variant="outlined" 
                                disabled={true}                                            
                                value={invoiceClient?.code &&  invoiceClient?.name ? `${invoiceClient.code} - ${invoiceClient.name}`: ""}
                                InputProps={{
                                    endAdornment: ( <InputAdornment position="start">
                                            <IconButton onClick={() => setShowInvoiceClientSearch(true)}><SearchIcon /></IconButton>
                                        </InputAdornment> 
                                    )                                              
                                }}                                                                                                                         
                            />                                        
                        </div>
                    </Box>

                    <p style={{padding: "1rem 0 0 1rem" }}>You are attempting to merge the following jobs:</p> 
                    <ul>
                    {selectedJobs.map(job => (
                        <li key={job.id}>{job.name}</li>
                    ))}
                    </ul>

                        <Modal.Footer>
                        <Button               
                            disabled={newName.length === 0 || client === null || invoiceClient === null}         
                            onClick={() => handleConfirmation(newName, client, invoiceClient)}
                        >
                            Merge
                        </Button>
                        <Button color="secondary" onClick={(e) => handleModalClose()}>
                            Cancel
                        </Button>
                    </Modal.Footer>                  
                
            </CenteredModal>
            }
            {(showInvoiceClientSearch || showClientSearch) &&
                <ClientSearchDialog handleClientSelection={handleClientSearchResult} handleModalClose={handleCloseClientSearch} />
            }</>
}

export default MergeJobDialog;